export class CreateHomeDto {
  homeName?: string;
  homeBuilderId?: string;
  homeBuilderName?: string;
  homeRange?: string;
  homeLotSize?: number;
  homeBedNo?: number;
  homeBathNo?: number;
  homeGarageNo?: number;
  homeFromPrice?: number;
  homeToPrice?: number;
  homeLevelPath?: string;
  homeStorey?: string;
  isRequest?: boolean;
  homeFloorplanMapBase64?: string;
}
